import type { ReactNode } from 'react';
import { Paper, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconInbox } from '@tabler/icons-react';

export function EmptyState({
  title,
  children,
  action,
  icon,
}: {
  title: string;
  children?: ReactNode;
  action?: ReactNode;
  icon?: ReactNode;
}) {
  return (
    <Paper withBorder p="xl" radius="md" className="pb-sunken">
      <Stack align="center" gap="xs" ta="center">
        <ThemeIcon variant="light" color="gray" size="xl" radius="xl" aria-hidden>
          {icon ?? <IconInbox size={22} />}
        </ThemeIcon>
        <Text fw={600}>{title}</Text>
        {children && (
          <Text size="sm" c="dimmed" maw={460}>
            {children}
          </Text>
        )}
        {action}
      </Stack>
    </Paper>
  );
}
